import { preloadRoute } from "../routes";
import { prefetchGet } from "./api";

const DASHBOARD_QUERY = { windowDays: 30, inactivityDays: 7 };

const inferRouteKey = (path) => {
  if (!path || path === "/") return "dashboard";
  if (path.startsWith("/clients/")) return "clientDetail";
  if (path.startsWith("/clients")) return "clients";
  if (path.startsWith("/groups")) return "workGroups";
  if (path.startsWith("/programs/session-builder")) return "sessionBuilder";
  if (path.startsWith("/programs/assistant/drafts")) return "programDraftPreview";
  if (path.startsWith("/programs/assistant")) return "programmingAssistantNew";
  if (path.startsWith("/programs")) return "programs";
  if (path.startsWith("/sessions/edit")) return "sessionBuilder";
  if (path.startsWith("/sessions")) return "sessionsLibrary";
  if (path.startsWith("/exercises")) return "exercisesLibrary";
  if (path.startsWith("/messages")) return "messages";
  if (path.startsWith("/feedback")) return "feedbackInbox";
  if (path.startsWith("/tests")) return "tests";
  if (path.startsWith("/settings/assistant")) return "programmingAssistantProfile";
  if (path.startsWith("/settings")) return "settings";
  return null;
};

const warmDataForPath = (path) => {
  if (!path || path === "/") {
    prefetchGet("/coach/clients/summary", {
      query: DASHBOARD_QUERY,
      cacheTtlMs: 15000,
    });
    return;
  }

  if (path.startsWith("/clients")) {
    prefetchGet("/clients", { cacheTtlMs: 20000 });
    return;
  }

  if (path.startsWith("/groups")) {
    prefetchGet("/coach/groups", { cacheTtlMs: 12000 });
    return;
  }

  if (path.startsWith("/programs")) {
    if (path.startsWith("/programs/assistant")) {
      prefetchGet("/coach/programming-profile", { cacheTtlMs: 0 });
      prefetchGet("/coach/programming-assistant/providers", { cacheTtlMs: 0 });
      prefetchGet("/clients", { cacheTtlMs: 20000 });
      prefetchGet("/exercises", {
        query: { limit: 200, offset: 0, format: "v2" },
        cacheTtlMs: 10000,
      });
      return;
    }
    prefetchGet("/programs", { cacheTtlMs: 15000 });
    prefetchGet("/sessions", { cacheTtlMs: 15000 });
    return;
  }

  if (path.startsWith("/sessions")) {
    prefetchGet("/sessions", { cacheTtlMs: 15000 });
    return;
  }

  if (path.startsWith("/exercises")) {
    prefetchGet("/exercises", {
      query: { limit: 60, offset: 0, format: "v2" },
      cacheTtlMs: 10000,
    });
    return;
  }

  if (
    path.startsWith("/messages") ||
    path.startsWith("/settings") ||
    path.startsWith("/tests") ||
    path.startsWith("/feedback")
  ) {
    if (path.startsWith("/settings/assistant")) {
      prefetchGet("/coach/programming-profile", { cacheTtlMs: 0 });
      prefetchGet("/coach/programming-assistant/providers", { cacheTtlMs: 0 });
      prefetchGet("/exercises", {
        query: { limit: 200, offset: 0, format: "v2" },
        cacheTtlMs: 10000,
      });
    }
    if (path.startsWith("/feedback")) {
      prefetchGet("/coach/feedback", { query: { limit: 25 }, cacheTtlMs: 8000 });
    }
  }
};

export const warmNavigationTarget = (path) => {
  const routeKey = inferRouteKey(path);
  if (routeKey) {
    preloadRoute(routeKey);
  }
  warmDataForPath(path);
};

export const warmStartupData = () => {
  warmDataForPath("/");
  warmDataForPath("/clients");
  warmDataForPath("/groups");
  warmDataForPath("/programs");
};
